import React from "react";

import { OPTION_CLOSE } from "src/constants/images";

const Option = ({ name, onClick, count }) => {
  return (
    <div className="filter-chip-card">
      <div>
        {name ? name : ""}{" "}
        <span style={{ color: "grey", fontSize: "12px", marginLeft: "4px" }}>
          {count ? `(${count})` : ""}
        </span>
      </div>
      {
        <svg
          onClick={onClick}
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          viewBox="0 0 24 24"
          width="18px"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      }
    </div>
  );
};

export default Option;
